document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('.product_variant_sb-flavours-wrapper');

    if (!wrappers.length) {
        return;
    }

    wrappers.forEach((wrapper) => {
        const variants = wrapper.querySelectorAll('.product-grouping li');

        if (!variants.length) {
            return;
        }

        const currentProductHandle = wrapper.dataset.currentProductHandle || '';

        variants.forEach((variant) => {
            const link = variant.querySelector('a');
            const href = link?.getAttribute('href');

            if (href && currentProductHandle && href.includes(currentProductHandle)) {
                variant.classList.add('selected');
            }

            variant.addEventListener('click', () => {
                variants.forEach((item) => item.classList.remove('selected'));
                variant.classList.add('selected');
            });
        });
    });
});

/* ============================================================
   "+" Add-to-cart button — adds a single grouped product to
   the cart and then opens the GoKwik side-cart drawer.
   ============================================================ */
(function () {
    'use strict';

    async function addVariantToCart(btn) {
        const variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId) return;

        // ── Loading state ──────────────────────────────────────
        btn.disabled = true;
        btn.classList.add('pgAtc--loading');

        try {
            const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
                ? window.Shopify.routes.root
                : '/';

            const response = await fetch(cartRoot + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                    items: [{ id: variantId, quantity: 1 }],
                    sections: ['cart-icon-bubble'],
                    sections_url: window.location.pathname,
                }),
            });

            if (!response.ok) throw new Error('Add to cart failed: ' + response.status);

            const data = await response.json();

            // ── Update cart bubble / icon count ────────────────
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble && data.sections && data.sections['cart-icon-bubble']) {
                bubble.innerHTML = data.sections['cart-icon-bubble'];
            }

            // ── Success state ──────────────────────────────────
            btn.classList.remove('pgAtc--loading');
            btn.classList.add('pgAtc--success');
            const iconEl = btn.querySelector('.product-grouping__atc-icon');
            if (iconEl) iconEl.textContent = '✓';

            // ── Open GoKwik side-cart drawer ───────────────────
            setTimeout(function () {
                if (typeof window.openGokwikSideCart === 'function') {
                    window.openGokwikSideCart();
                }
            }, 300);

            // ── Reset button after 1.5 s ───────────────────────
            setTimeout(function () {
                btn.classList.remove('pgAtc--success');
                if (iconEl) iconEl.textContent = '+';
                btn.disabled = false;
            }, 1500);

        } catch (err) {
            console.error('[product-variant-pdp] Add to cart failed:', err);
            btn.classList.remove('pgAtc--loading');
            const iconEl = btn.querySelector('.product-grouping__atc-icon');
            if (iconEl) iconEl.textContent = '+';
            btn.disabled = false;
        }
    }

    // Delegated listener — works even if DOM renders late
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.product-grouping__atc-btn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        
        // ── Push CleverTap Event ───────────────────────────
        if (typeof clevertap !== 'undefined' && clevertap.event && clevertap.event.push) {
            const eventPayload = {
                "Product Name": btn.dataset.productTitle || '',
                "Product Handle": btn.dataset.productHandle || '',
                "Price": parseFloat(btn.dataset.productPrice) || 0,
                "Page URL": window.location.href
            };
            console.log("✅ CleverTap Event Fired: ATC_More_flavour", eventPayload);
            clevertap.event.push("ATC_More_flavour", eventPayload);
        } else {
            console.log("⚠️ CleverTap is not loaded on this page, but ATC_More_flavour would have fired.");
        }

        if (!btn.disabled) addVariantToCart(btn);
    });
})();
